import React, { useState } from "react";
import { AIChatPanel } from "@/components/AIChatPanel";
import { Sparkles, X, MessageSquare } from "lucide-react";
import { useLocation } from "react-router-dom";

/** Floating chat launcher; hidden on the /assistant page (duplicate UX). */
export default function AssistantWidget() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  if (location.pathname === "/assistant" || location.pathname === "/") return null;

  return (
    <>
      {!open && (
        <button
          onClick={() => setOpen(true)}
          data-testid="assistant-widget-launcher"
          aria-label="Abrir asistente financiero"
          className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-[#0F291E] hover:bg-[#1C7C54] text-white shadow-xl flex items-center justify-center transition-all"
        >
          <MessageSquare className="w-6 h-6" />
        </button>
      )}
      {open && (
        <div
          data-testid="assistant-widget-panel"
          className="fixed bottom-6 right-6 z-40 w-[380px] max-w-[calc(100vw-2rem)] h-[560px] max-h-[calc(100vh-4rem)] rounded-2xl border border-[#EBEBEA] bg-white shadow-2xl flex flex-col overflow-hidden"
        >
          <div className="flex items-center justify-between px-4 py-3 border-b border-[#EBEBEA] bg-[#FAFAF9]">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-lg bg-[#1C7C54]/10 flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-[#1C7C54]" />
              </div>
              <div className="font-display font-semibold text-[#0A110E]">Asistente</div>
            </div>
            <button
              onClick={() => setOpen(false)}
              data-testid="assistant-widget-close"
              className="p-1.5 rounded-lg hover:bg-[#EBEBEA]"
              aria-label="Cerrar"
            >
              <X className="w-4 h-4 text-[#5F7368]" />
            </button>
          </div>
          <div className="flex-1 flex flex-col p-3 min-h-0">
            <AIChatPanel variant="widget" />
          </div>
        </div>
      )}
    </>
  );
}
